import { Dialog, DialogTitle, Grid } from "@material-ui/core";
import { Header } from "../styles/SearchDialog";
import StringService from "../../../utils/stringService";
import useModalParametersController from "./controllers/ModalParametersController";
import {
  HelperText,
  ImageContainer,
  StyledChip,
  IconButtonCustom,
} from "./styles/styles";

import QyonLogo from "../../../assets/imgs/qyon-logo.png";
import { Close } from "@material-ui/icons";
import { useState } from "react";
import Loading from "../../../components/basics/Loading";

const View = ({ open = false, setOpen = () => {}, entity = "" }) => {
  const { closeDialog, returnEntityBody } = useModalParametersController();
  const [loading, setLoading] = useState(false);

  return (
    <Dialog
      fullWidth={true}
      maxWidth="lg"
      open={open}
      onClose={(_, reason) => closeDialog(setOpen, reason)}
      aria-labelledby="dialog-title"
    >
      <Loading open={loading} />
      <DialogTitle id="dialog-parameters-title">
        <Header>
          <Grid container wrap="nowrap">
            <ImageContainer>
              <img src={QyonLogo} alt="Qyon Logo" />
            </ImageContainer>
            <StyledChip
              bgcolor="primary"
              label={
                <>
                  {`Parâmetros: ${StringService.capitalize(entity)}`}
                  <IconButtonCustom
                    size="small"
                    onClick={() => closeDialog(setOpen)}
                  >
                    <Close />
                  </IconButtonCustom>
                </>
              }
            />
          </Grid>
        </Header>
      </DialogTitle>
      {returnEntityBody(entity, setOpen, setLoading)}
      <HelperText children="*As alterações efetuadas nesta tela serão válidas para todas as empresas e usuários cadastrados no sistema." />
    </Dialog>
  );
};

/**
 * Modal de parâmetros por módulo.
 *
 * @param {{
 * open: Boolean,
 * setOpen: Function,
 * entity: String
 * }} props - Propriedades á serem desestruturadas.
 *
 * @param open - Diz se o modal está aberto ou não;
 * @param setOpen - Função set que controla o estado de aberto ou não;
 * @param entity - Controla qual qual módulo o modal está se referindo, utilizando
 * a função "returnEntityBody" vinda do controller;
 *
 */
const ModalParameters = ({ ...props }) => <View {...props} />;
export default ModalParameters;
